import r from "../managers/braze-instance.js";
import je from "./in-app-message-manager-factory.js";
export function getDeferredInAppMessage() {
  if (r.rr()) return je.ra().sa();
}
